const CHINESE_NUMBERS = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];

/** 将数字转换为中文数字（1-99） */
export function toChineseNum(num: number): string {
    if (num < 1 || num > 99) return String(num);
    if (num <= 9) return CHINESE_NUMBERS[num];
    if (num === 10) return '十';
    if (num < 20) return `十${CHINESE_NUMBERS[num % 10]}`;
    const tens = CHINESE_NUMBERS[Math.floor(num / 10)];
    const ones = num % 10;
    return `${tens}十${ones > 0 ? CHINESE_NUMBERS[ones] : ''}`;
}

/** 个位数补零，1-9 → 01-09，>=10 原样返回字符串 */
export function padZero(num: number): string {
    return num < 10 ? `0${num}` : String(num);
}

export function pxToRem(px: number): string {
    const base = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return `${px / base}rem`;
}

export function px2rem(px: number): string {
    const base = 14;
    return `${(px / base).toFixed(4)}rem`;
}

// 判断对象是否为空
export const isEmptyObject = (obj: unknown): boolean => {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
};
export const goLogin = () => {
    const href = import.meta.env.VITE_MODE === 'prod' ? '/login' : `/flag-os/login`;
    location.href = `${href}?redirect_url=${encodeURIComponent(location.href)}`;
};

export const scrollToAnchor = (id: string, options?: { headerOffset?: number; maxRetries?: number; retryInterval?: number }) => {
    const headerOffset = options?.headerOffset ?? 64;
    const maxRetries = options?.maxRetries ?? 15;
    const retryInterval = options?.retryInterval ?? 100;

    const doScroll = () => {
        const element = document.getElementById(id);
        if (!element) return false;
        const top = element.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        return true;
    };

    if (doScroll()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
        attempts += 1;
        if (doScroll() || attempts >= maxRetries) {
            clearInterval(timer);
        }
    }, retryInterval);
};

/** 将消息摘要中的 HTML 标签与实体（如 &nbsp;）清理为纯文本 */
export function formatMessageSnippet(text?: string | null): string {
    if (!text) {
        return '';
    }

    const withoutTags = text.replace(/<[^>]*>/g, ' ');
    const textarea = document.createElement('textarea');
    textarea.innerHTML = withoutTags;

    return textarea.value
        .replace(/\u00A0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
